import { motion } from 'motion/react';

import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import styles from './Message.module.css';

const Message = ({ message, authorFontSize, currentState, winId }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  const isWinner = currentState === 'S4';

  return (
    <div className={styles.wrapper}>
      {message && (
        <motion.div
          animate={{ opacity: isWinner && winId !== message.id ? 0 : 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className={styles.blockMsg}
        >
          <div className={styles.avatar}>
            <div
              className={styles.avatarBg}
              style={{
                background: `url(${
                  iconsSources[message?.channel]
                }) center/cover no-repeat `,
              }}
            />
            <img
              src={
                (message?.image !== '1' && message?.image) ||
                iconsSources[message?.channel]
              }
              alt={message?.author}
              onError={errorHandler}
            />
            <div className={styles.bodrerImg} />
          </div>
          <div
            className={styles.nameAuthor}
            style={{ fontSize: `${authorFontSize}rem` }}
          >
            {message?.author
              ? message.author.length > 40
                ? `${message.author.slice(0, 40)}...`
                : message.author
              : hideNumber(message?.senderNumber)}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default Message;
